import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import Metrics from '../components/sections/Metrics';
import About from '../components/sections/About';
import Gallery from '../components/sections/Gallery';
import Cases from '../components/sections/Cases';
import Management from '../components/sections/Management';
import Contact from '../components/sections/Contact';
import ScrollProgress from '../components/ui/ScrollProgress';
import { ScrollTrigger } from '../hooks/useGsap';
// === PROCESSO SELETIVO (temporário) — ver COMO-REMOVER-O-PS.md ===
import ProcessoSeletivoCTA from '../components/sections/ProcessoSeletivoCTA';
import { psConfig } from '../data/processoSeletivoData';
// === FIM PROCESSO SELETIVO ===

const Home = () => {
  // Refresh ScrollTrigger on dynamic content / window resize after mount
  useEffect(() => {
    const id = setTimeout(() => ScrollTrigger.refresh(), 400);
    return () => clearTimeout(id);
  }, []);

  return (
    <>
      <ScrollProgress />
      <Header />
      <main>
        {/* === PROCESSO SELETIVO (temporário) — ver COMO-REMOVER-O-PS.md === */}
        {psConfig.ativo && <ProcessoSeletivoCTA />}
        {/* === FIM PROCESSO SELETIVO === */}
        <Hero />
        <Metrics />
        <About />
        <Gallery />
        <Cases />
        <Management />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
